import { Column } from '../objects/column';
export const PAYMEN_WAITING_COLUMN: Column[] = [
    {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'current_version__status',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'folder',
        field_name: 'FOLDER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'event',
        field_name: 'EVENT',
        checked: true,
        order_by: 'event__localization__name',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'society',
        field_name: 'SOCIETY',
        checked: true,
        order_by: 'current_version__for_user__company__unaccent__icontains',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'current_version__total_cost',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'payment-done',
        field_name: 'PAYMENT_DONE',
        checked: true,
        order_by: 'current_version__total_paid',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'payment-remaining',
        field_name: 'PAYMENT_REMAINING',
        checked: true,
        order_by: 'current_version__balance',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'announced-payment',
        field_name: 'ANNOUNCED_PAYMENT',
        checked: true,
        order_by: 'current_version__payment_type',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'payment-waiting-type',
        field_name: 'PAYMENT_WAITING_TYPE',
        checked: true,
        order_by: 'current_version__payment_mode',
        fixed_width: false,
        last_updated: false,
        width: null
    },
    {
        label: 'due-date',
        field_name: 'DUE_DATE',
        checked: true,
        order_by: 'current_version__due_date',
        fixed_width: false,
        last_updated: false,
        width: null
    }
];